const f = {
  color: {
    light: {
      background: "white",
      green: "#47c47dff",
      slate: "#82a7baff",
      red: "#e54a32ff",
      yellow: "#fabf5aff",
      purple: "#ad82d8ff",
      charcoal: "#abb9c7ff"
    },
    dark: {
      background: "#263aadff",
      green: "#56f09eff",
      slate: "#47c2ffff",
      red: "#ff4747ff",
      yellow: "#ffb83dff",
      purple: "#c285ffff",
      charcoal: "#abb9c7ff"
    }
  }
};
export {
  f as statusDot
};
